import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, DoCheck, HostListener, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';


import { environment } from 'src/environments/environment';
import { YoutubeVideoComponent } from '../youtube-video/youtube-video.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'calsoft-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {

  @Input() brands: any[] = [];
  @Input() formGroupId: any;
  @Input() item: any;
  width: any;
  height: any;
  gapBetweenImage: any;
  customField12: any;
  customField11: any;
  isMobile: boolean = false;

  screenWidth: number = window.innerWidth;

  public bannerServerPath = environment.commonImageApi + '/commonSlider/';
  public bannerServerPath1 = environment.commonImageApi + '/home/';

  public LogoSliderConfig: any;
  public LogoSliderConfig1: any;
  public LogoSliderConfig4: any;

  imagesPerLoad = 2;
  loadedImages = 2;
  @Input() data: any;
  public youtubeUrl = environment.youtubeUrl;
  @ViewChild('owlElement', { static: false }) owlElement: CarouselComponent;
  @ViewChild('owlElements', { static: false }) owlElements: CarouselComponent;
  regConfig: any[] = [

  ];
  displayWebCount: number;
  displayMobileCount: number;
  constructor(private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private categoryService: CategoryService,
    private breakpointObserver: BreakpointObserver) {
      this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
     }
 

     sanitizeHtml(html: string): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }


  @HostListener('window:scroll', ['$event'])
  nScroll(event) {
    
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      this.loadMoreImages();
    }
  }



  getStyleClass(index: number): string {
    const row = Math.floor(index / 3); // Determine the row number
    const col = index % 3; // Determine the column within the row

    // If the column is odd (1 or 3 in zero-based index), apply alternate style
    return (col % 2 === 1) ? 'alt-style' : '';
  }

  calcFlex(): string {
    return 'calc(33.33% - 20px)';
  }
  carouselOptions = {
    loop: true, // Ensures continuous sliding
    margin: 10, // Adds space between the cards
    nav: false, // Disables navigation buttons (next and previous)
    dots: false, // Disables pagination dots
    autoplay: true, // Enables automatic sliding
    autoplayTimeout: 3000, // Sets the interval between automatic slides
    autoplayHoverPause: true, // Pauses autoplay on hover
    items: 3, // Specifies the number of items visible at a time
    responsive: {
      0: {
        items: 1 // Shows 1 card on small screens
      },
      600: {
        items: 3 // Shows 2 cards on medium screens
      },
      1000: {
        items: 4 // Shows 3 cards on larger screens
      }
    },
    slideBy: 1, // Slides one item at a time
    smartSpeed: 800, // Controls the speed of the slide transition
    rewind: true, // Rewinds to the first slide when the last slide is reached
    animateOut: 'fadeOut', // Animation effect when a slide goes out
    animateIn: 'fadeIn' // Animation effect when a slide comes in
  };




  loadMoreImages() {
    this.loadedImages += this.imagesPerLoad;
  }
   
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      this.loadMoreImages();
    }
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
 
    const elements = document.querySelectorAll('.feature-row');
    elements.forEach((el: any) => {
      const rect = el.getBoundingClientRect();
      if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
        el.classList.add('slide-in');
      
      } else {
        el.classList.remove('slide-in');
       
      }
    });
  }
  
  LogoSlider = {
    nav: false,
    dots: false,
    items: 3,
    margin: 24,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    stagePadding: 80,
   
    responsive: {
      1200: {
        items: 5
      },
      992: {
        items: 4
      },
      767: {
        items: 3
      },
      576: {
        items: 2
      },
      0: {
        items: 1
      }
    }

  };
  

  LogoSlider1 = {
    ...sliderOpt,
    nav: false,
    dots: true,
    items: 3,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 5
      },
      576: {
        items: 4
      },
      600: {
        items: 3
      },
      0: {
        items: 2
      }
    }
  }
  value: any;
  value2: any;

  ngOnInit(): void {    
    // Defensive: ensure item exists so template and carousel code don't read undefined
    this.item = this.item || ({} as any);

    this.value2 = 20 * 2;
    this.value = 100 - this.value2;

    const safeInt = (v: any, fallback = 1) => {
      const n = parseInt(v);
      return isNaN(n) ? fallback : n;
    };

    const cf14 = safeInt(this.item.customField14, 3);
    const cf33 = safeInt(this.item.customField33, 1);

    this.displayWebCount = 100 / (cf14 + 1);
    this.displayMobileCount = 100 / (cf33 + 1);

    if (typeof this.item.gapBetweenImage !== 'string') {
      this.item.gapBetweenImage = String(this.item.gapBetweenImage || '0');
    }
    if (typeof this.item.gapBetweenImage === 'string' && this.item.gapBetweenImage.endsWith('px')) {
      this.item.gapBetweenImage = this.item.gapBetweenImage.slice(0, -2);
    }

    const autoplayTimeout = Number(this.item.customField21) || 3000;
    try {
      this.LogoSlider.autoplayTimeout = autoplayTimeout;
      this.LogoSlider1.autoplayTimeout = autoplayTimeout;
      this.LogoSlider2.autoplayTimeout = autoplayTimeout;
      this.LogoSlider3.autoplayTimeout = autoplayTimeout;
      this.LogoSlider4.autoplayTimeout = autoplayTimeout;
      this.LogoSlider5.autoplayTimeout = autoplayTimeout;
      this.LogoSlider6.autoplayTimeout = autoplayTimeout;
    } catch (e) {
      // ignore if any LogoSlider* is missing
    }

    this.LogoSlider.margin = this.item.gapBetweenImage;
    this.carouselOptions.margin = this.item.gapBetweenImage;

    this.LogoSliderConfig = this.LogoSlider;
    this.LogoSlider1.margin = this.item.gapBetweenImage;
    this.LogoSliderConfig1 = this.LogoSlider1;
    this.LogoSlider4.margin = this.item.gapBetweenImage;
    this.LogoSliderConfig4 = this.LogoSlider4;

    // Safe assignment to responsive maps
    try {
      this.LogoSlider1.responsive[767].items = cf14;
      this.LogoSlider1.responsive[576].items = cf14;
      this.LogoSlider.responsive[767].items = cf14;
      this.LogoSlider.responsive[576].items = cf33;
      this.LogoSlider.responsive[1200].items = cf14;
      this.LogoSlider.responsive[992].items = cf14;
      this.LogoSlider1.responsive[600].items = cf33;
      this.LogoSlider1.responsive[0].items = cf33;
      this.LogoSlider4.responsive[767].items = cf14;
      this.LogoSlider4.responsive[576].items = cf14;
      this.LogoSlider6.responsive[767].items = cf14;
      this.LogoSlider6.responsive[576].items = cf14;
      this.LogoSlider.responsive[0].items = cf33;
      this.LogoSlider7.responsive[767].items = cf14;
      this.LogoSlider7.responsive[576].items = cf33;
      this.LogoSlider7.responsive[480].items = cf33;
      this.LogoSlider7.responsive[0].items = cf33;
      this.LogoSlider8.responsive[767].items = cf14;
      this.LogoSlider8.responsive[576].items = cf33;
      this.LogoSlider8.responsive[480].items = cf33;
      this.LogoSlider8.responsive[0].items = cf33;
    } catch (e) {
      // ignore malformed responsive structures
    }

    this.screenWidth = window.innerWidth;
  }


  customOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 600,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      760: {
        items: 1
      },
      1000: {
        items: 1
      }
    },
    nav: true
  }

  goToCategory(menu) {
    this.commonService.selectedCategory(menu.categoryName, menu.categoryId, menu);

  }


  imageNavigation(id) {

    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  catId: any;

  goToCategories(id: any) {
    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url) {
    this.commonService.goToLink(url)
   
  }

  @ViewChild('owlCar') owlCarousel: CarouselComponent;

  LogoSlider5 = {
    nav: false,
    dots: false,
    items: 1,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 1
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

  LogoSlider2 = {
    nav: false,
    dots: true,
    items: 1,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 1
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

  LogoSlider3 = {
    nav: false,
    dots: true,
    items: 1,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 5
      },
      576: {
        items: 4
      },
      480: {
        items: 3
      },
      0: {
        items: 2
      }
    }
  }


  LogoSlider4 = {
    ...sliderOpt,
    nav: true,
    dots: false,
    items: 3,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    navText: ['&#8249', '&#8250;'],
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 5
      },
      576: {
        items: 4
      },
      480: {
        items: 3
      },
      0: {
        items: 1,
        stagePadding: 30
      }
    }
  }

  LogoSlider6 = {
    ...sliderOpt,
    nav: false,
    dots: false,
    items: 3,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    navText: ['&#8249', '&#8250;'],
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 1
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

  LogoSlider7 = {
    ...sliderOpt,
    nav: false,
    dots: true,
    items: 4,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: false,
    navText: ['&#8249', '&#8250;'],
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 4
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

    LogoSlider8 = {
    ...sliderOpt,
    nav: false,
    dots: false,
    items: 4,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: false,
    navText: ['&#8249', '&#8250;'],
    autoplayTimeout: 3000,
    responsive: {
      767: {
        items: 4
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

  @ViewChild('vedio') vedio: TemplateRef<any>;

  showModal(data: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(YoutubeVideoComponent, {
        width: '790px',
        height: '500px',
        data: { data: data, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });

    }
    else {
      let dialogRef = this.dialog.open(YoutubeVideoComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: data, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });
    }
  }

  closeModal() {
    this.dialog.closeAll();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }

  shouldShowBrand(brand: any): boolean {
    const isMobile = this.screenWidth <= 767;
    const isTab = this.screenWidth > 767 && this.screenWidth <= 1024;
    const isWeb = this.screenWidth > 1024;

    switch (brand.customField22) {
      case '1':
        return true;         // Show on all devices
      case '2':
        return isMobile;     // Show on mobile only
      case '3':
        return isTab;        // Show on tablet only
      case '4':
        return isWeb;        // Show on web only
      default:
        return true;         // Fallback to show
    }


  }
}
export const sliderOpt = {
  items: 1,
  loop: true,
  margin: 20,
  responsiveClass: true,
  nav: true,
  navText: ['<i class="icon-angle-left">', '<i class="icon-angle-right">'],
  dots: true,
  smartSpeed: 400,
  autoplay: false,
  autoplayTimeout: 15000
}